import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.css']
})
export class SliderComponent implements OnInit {
  slides = [
    {
      img: '../../assets/img/banners/banner1.jpg',
      text1: 'Quality Assured',
      text2: 'Competitive Prices',
      text3: 'Finance terms to suit you',
      button: 'Buy a car',
      background : '#343434',
      padding: '15px 36px',
      marginTop: '35px'

},
    {img: '../../assets/img/banners/banner2.jpg', url: '/showroom'},
    {img: '../../assets/img/banners/banner3.jpg', url: '/showroom'}
  ];
  slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    fade: true,
    arrows: false,
    autoplaySpeed: 10000
  };


  constructor() {
  }

  ngOnInit() {
  }

}
